module.exports = __webpack_public_path__ + "img/60.4ef3023f.jpg";